import { render, staticRenderFns } from "./TransactionToggle.vue?vue&type=template&id=610abd78&scoped=true&"
import script from "./TransactionToggle.vue?vue&type=script&lang=js&"
export * from "./TransactionToggle.vue?vue&type=script&lang=js&"
import style0 from "./TransactionToggle.vue?vue&type=style&index=0&id=610abd78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610abd78",
  null
  
)

export default component.exports